import { render, staticRenderFns } from "./FileTab.vue?vue&type=template&id=b12a57d8"
import script from "./FileTab.vue?vue&type=script&lang=js"
export * from "./FileTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports